<template>
  <div class="editor-container">
    <div id="gjs"></div>
    <!-- 可选的自定义工具栏 -->
    <div v-if="showToolbar" class="custom-toolbar">
      <button @click="saveContent">保存</button>
      <button @click="previewContent">预览</button>
    </div>
  </div>
</template>

<script>
import 'grapesjs/dist/css/grapes.min.css'
const grapesjs = require('grapesjs')

export default {
  name: 'PageBuilder',
  props: {
    // 初始内容
    initialContent: {
      type: String,
      default: ''
    },
    // 是否显示工具栏
    showToolbar: {
      type: Boolean,
      default: false
    },
    // 是否只允许编辑文本
    textOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null
    }
  },
  mounted() {
    this.initEditor()
  },
  methods: {
    initEditor() {
      const options = {
        container: '#gjs',
        height: '70%',
        width: 'auto',
        fromElement: false,
        storageManager: false,
        panels: { defaults: [] },
        canvas: {
          styles: [],
          scripts: []
        },
        // 自定义编辑配置
        components: {
          defaults: {
            editable: this.textOnly,
            draggable: false,
            droppable: false,
            removable: false,
            copyable: false,
            resizable: false
          }
        }
      }

      this.editor = grapesjs.init(options)

      // 设置初始内容
      if (this.initialContent) {
        this.editor.setComponents(this.initialContent)
      }

      // 配置编辑器事件
      this.setupCustomEvents()
    },

    setupCustomEvents() {
      // 内容更改事件
      this.editor.on('component:update', () => {
        const content = this.editor.getHtml()
        this.$emit('change', content)
      })

      // 选中组件事件
      this.editor.on('component:selected', (component) => {
        if (component) {
          // 自定义选中行为
          this.handleComponentSelect(component)
        }
      })
    },

    handleComponentSelect(component) {
      // 根据组件类型设置可编辑性
      if (this.textOnly) {
        const isText = component.is('text') || 
                      component.get('type') === 'text' ||
                      component.get('tagName') === 'p' ||
                      component.get('tagName') === 'span'
        
        component.set('editable', isText)
      }
    },

    // 保存内容
    saveContent() {
      const content = this.editor.getHtml()
      this.$emit('save', content)
    },

    // 预览内容
    previewContent() {
      const content = this.editor.getHtml()
      // 创建预览窗口
      const win = window.open('', '_blank')
      win.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>预览</title>
            <style>
              body { margin: 20px; font-family: Arial, sans-serif; }
            </style>
          </head>
          <body>${content}</body>
        </html>
      `)
    },

    // 获取内容
    getContent() {
      return this.editor.getHtml()
    },

    // 设置内容
    setContent(content) {
      this.editor.setComponents(content)
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  }
}
</script>

<style scoped>
.editor-container {
  position: relative;
  height: 100%;
  min-height: 300px;
  border: 1px solid #ddd;
}

.custom-toolbar {
  position: absolute;
  top: -40px;
  right: 0;
  padding: 5px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-bottom: none;
}
.editor-controls {
    padding: 10px;
    background: #f5f5f5;
    border-top: 1px solid #ddd;
  }
  .editor-controls button {
    margin-right: 10px;
    padding: 5px 15px;
    background: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .editor-controls button:hover {
    background: #45a049;
  }
 
.custom-toolbar button {
  margin-left: 5px;
  padding: 4px 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
}

.custom-toolbar button:hover {
  background: #f0f0f0;
}

/* 自定义编辑器样式 */
:deep(.gjs-cv-canvas) {
  width: 100%;
  height: 100%;
  top: 0;
}

:deep(.gjs-frame-wrapper) {
  padding: 0;
}

/* 隐藏不需要的UI元素 */
:deep(.gjs-pn-panel),
:deep(.gjs-toolbar),
:deep(.gjs-layer-badge),
:deep(.gjs-layer-move),
:deep(.gjs-layer-vis),
:deep(.gjs-am-preview-cont),
:deep(.gjs-am-assets-cont),
:deep(.gjs-block-category),
:deep(.gjs-pn-views),
:deep(.gjs-pn-options),
:deep(.gjs-pn-devices-c) {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PageBuilder.vue